import React from 'react';
import styled from 'styled-components';
import ResourceCard from './components/resourceCard/ResourceCard';
import ReservedCard from './components/reservedCard/ReservedCard';
import IDHelpers from '../../../core/helpers/IDHelper';
import ModalConfirmation from '../procedures/components/Modal/Modal';
import ContentModalOneButton from '../procedures/components/ContentModalOneButton';
import iconWarning from '../../../assets/illustrations/warning.svg';
import Spinner from '../../components/Spinner';
import TabletIcon from '../../../assets/icons/resources/tablet.svg';
import TabletComputer from '../../../assets/icons/resources/computer/computadora.svg';
import GroopRoomDisabled from '../../../assets/icons/resources/group-room-disabled.svg';
import SpacesDisabled from '../../../assets/icons/resources/Spaces-disabled.svg';
import { SubsectionHeader } from '@/presentation/reusables/SectionHeader';
import ModuleContainer from '@/presentation/components/Container';
import IconAlert from '../../../assets/icons/icon-alert.svg';

interface MeanViewProps {
  goBackButton: () => void;
  reservedTablets: any;
  penalizedResource: any;
  statusResource: any;
  isLoading: boolean;
  handleSelectResource: (id: string) => void;
  handleValidationResource: (path: string, type: 'T' | 'C' | 'S') => void;
  studentCampus: string;
  inPeriodCurrent?: boolean;
  subsectionHeader: any;
}

const Container = styled.div`
  display: grid;
  margin-bottom: 16px;
  gap: 16px;
  grid-template-columns: repeat(2, 1fr);

  @media (max-width: 639.5px) {
    gap: 8px;
    grid-template-columns: repeat(1, 1fr);
  }

  // @media (min-width: 1280px) {
  //   width: 364px;
  // }
`;
const NotificationContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: #fabd00; /* Color de fondo */
  padding: 12px 16px;
  border-radius: 4px;
  margin: 0px 0px 16px 0px;
  font-family: Arial, sans-serif;

  /* Responsividad */
  @media (max-width: 640px) {
    margin: 0px 0px 16px 0px;
    padding: 10px 12px;
  }
`;

const TitleReservations = styled.div`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #161d1f;
  padding-top: 32px;
  padding-bottom: 24px;
`;

const Text = styled.p`
  color: #000;
  font-size: 14px;
  /* line-height: 1.5; */
  padding-left: 8px;
  /* margin: 0; */

  @media (max-width: 640px) {
    font-size: 12px;
  }
`;

const MeanView = (props: MeanViewProps) => {
  const {
    goBackButton,
    reservedTablets,
    penalizedResource,
    statusResource,
    handleSelectResource,
    handleValidationResource,
    isLoading,
    studentCampus,
    inPeriodCurrent,
    subsectionHeader
  } = props;
  return (
    <ModuleContainer containerType="subsection">
      <div>
        <SubsectionHeader
          title={subsectionHeader[2].title}
          onClick={goBackButton}
        />
        {isLoading ? (
          <Spinner />
        ) : (
          <>
            {!inPeriodCurrent && (
              <NotificationContainer>
                <img src={IconAlert} alt="icon-alert" />
                <Text
                  style={{
                    fontFamily: 'Lato'
                  }}
                >
                  La reserva de recursos está deshabilitada debido a que no
                  tienes una matrícula vigente.
                </Text>
              </NotificationContainer>
            )}
            <Container>
              <ResourceCard
                resourceTitle="Tablets"
                isDisabled={!inPeriodCurrent}
                inPeriodCurrent={inPeriodCurrent}
                icon={TabletIcon}
                onClick={() => {
                  if (inPeriodCurrent)
                    handleValidationResource('/reserva/tablet/registro', 'T');
                }}
                durationText="Entre 1 a 4 horas al día"
              />
              <ResourceCard
                resourceTitle="Computadoras"
                isDisabled={!inPeriodCurrent}
                inPeriodCurrent={inPeriodCurrent}
                icon={TabletComputer}
                onClick={() => {
                  if (inPeriodCurrent)
                    handleValidationResource(
                      '/reserva/computadora/registro',
                      'C'
                    );
                }}
                durationText="Entre 1 a 2 horas al día"
              />
              {inPeriodCurrent && (
                <ResourceCard
                  resourceTitle="Salas grupales"
                  isDisabled
                  icon={GroopRoomDisabled}
                  // onClick={() => {
                  //   handleValidationResource('/reserva/sala/registro', 'S');
                  // }}
                  durationText="Entre 1 a 2 horas al día"
                />
              )}
              {studentCampus !== 'CHICL' &&
                studentCampus !== 'VIRT' &&
                inPeriodCurrent && (
                  <ResourceCard
                    resourceTitle="Espacios universitarios"
                    isDisabled
                    icon={SpacesDisabled}
                    // onClick={() => {
                    //   handleValidationResource('/reserva/sala/registro', 'S');
                    // }}
                    durationText="Entre 1 a 2 horas al día"
                  />
                )}
            </Container>
            {reservedTablets && reservedTablets?.length > 0 && (
              <>
                <TitleReservations>Mis Reservas</TitleReservations>
                <Container>
                  {reservedTablets?.map((reserved: any) => (
                    <ReservedCard
                      key={IDHelpers.generateID()}
                      onClick={() => handleSelectResource(reserved.id)}
                      title={reserved.resourceName}
                      reservationDate={reserved.formatedDate}
                      reservationTime={`${reserved.hourStart} a ${reserved.hourEnd}`}
                      reservationLocation={reserved.ubication}
                      disabled={reserved.disabled}
                    />
                  ))}
                </Container>
              </>
            )}
          </>
        )}
      </div>
      <div data-testid="cmp-penalizedResource">
        <ModalConfirmation
          handleClose={() => penalizedResource.setShowModalPenaltie(false)}
          show={penalizedResource.showModalPenaltie}
        >
          <ContentModalOneButton
            style={{ textAlign: 'center' }}
            onClickButton={() => penalizedResource.setShowModalPenaltie(false)}
            textButton="Entendido"
            showInfo={false}
            img={null}
            title="Lo sentimos, por el momento no puedes realizar alguna reserva debido a que mantiene una sanción con la universidad."
          />
        </ModalConfirmation>
      </div>
      <div data-testid="cmp-statusResource">
        <ModalConfirmation
          handleClose={() => statusResource.setShowModalStatus(false)}
          show={statusResource.showModalStatus}
        >
          <ContentModalOneButton
            style={{ textAlign: 'center' }}
            onClickButton={() => statusResource.setShowModalStatus(false)}
            textButton="Entendido"
            showInfo={false}
            img={iconWarning}
            title="Este servicio no se encuentra disponible."
          />
        </ModalConfirmation>
      </div>
    </ModuleContainer>
  );
};
export default MeanView;
